import { AFFILIATE_PROGRAM_API } from 'modules/affiliate-program/api/affiliate-program-api'
import {
  AffiliateApiInterface,
  AffiliateFilterInterface,
} from 'modules/affiliate-program/types/affiliate-program-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'

interface UseAffiliatesInterface extends SwrPaginationInterface {
  filter: AffiliateFilterInterface
}

export function useAffiliates({ limit, pagination, filter }: UseAffiliatesInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AffiliateApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${filter.dateSince ? `&filter[dateSince]=${filter.dateSince}` : ''}${
    filter.dateTill ? `&filter[dateTill]=${filter.dateTill}` : ''
  }${filter.id ? `&filter[id]=${filter.id}` : ''}${
    filter.email ? `&filter[email]=${filter.email}` : ''
  }`

  const { data: affiliates } = useControlledSwr(() => {
    if (user && pagination.startFromId === undefined && limit && filter.dateSince !== null) {
      return [
        `${AFFILIATE_PROGRAM_API}/affiliate/list?pagination[limit]=${limit}${filterApi}`,
        RequestModuleEnum.Contacts,
      ]
    } else if (user && pagination.startFromId && limit) {
      return [
        `${AFFILIATE_PROGRAM_API}/affiliate/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`,
        RequestModuleEnum.Contacts,
      ]
    }
    return null
  }, fetcher)

  const { data: affiliatesCounter } = useSWR<CountInterface>(() => {
    if (user && pagination.startFromId === undefined && filter.dateSince !== null) {
      return `${AFFILIATE_PROGRAM_API}/affiliate/count?${filterApi}`
    }
    return null
  }, baseFetcher)

  return { affiliates, affiliatesCounter }
}
